// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bg-primary: #0f172a;
  --bg-secondary: #1e293b;
  --bg-card: rgba(30, 41, 59, 0.8);
  --accent-primary: #38bdf8;
  --accent-secondary: #22d3ee;
  --accent-aurora: #34d399;
  --text-primary: #f1f5f9;
  --text-secondary: #94a3b8;
  --border-color: rgba(148, 163, 184, 0.2);
  --error: #f87171;
  --success: #4ade80;
  --body-gradient-mid: #1e3a5f;
  --body-gradient-end: #134e4a;
}

@media (prefers-color-scheme: light) {
  :root {
    --bg-primary: #f1f5f9;
    --bg-secondary: #e2e8f0;
    --bg-card: rgba(255, 255, 255, 0.85);
    --accent-primary: #0284c7;
    --accent-secondary: #0891b2;
    --accent-aurora: #059669;
    --text-primary: #0f172a;
    --text-secondary: #475569;
    --border-color: rgba(71, 85, 105, 0.2);
    --error: #dc2626;
    --success: #16a34a;
    --body-gradient-mid: #bfdbfe;
    --body-gradient-end: #a7f3d0;
  }
}

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, sans-serif;
  background: linear-gradient(135deg, var(--bg-primary) 0%, var(--body-gradient-mid) 50%, var(--body-gradient-end) 100%) !important;
  background-attachment: fixed !important;
  color: var(--text-primary);
  min-height: 100vh;
  -webkit-font-smoothing: antialiased;
}

html {
  background: var(--bg-primary);
}

.app-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  max-width: 100vw;
}

.header {
  background: var(--bg-card);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid var(--border-color);
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo {
  font-size: 1.5rem;
  font-weight: 700;
  background: linear-gradient(135deg, var(--accent-primary), var(--accent-aurora));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.callsign-badge {
  background: linear-gradient(135deg, var(--accent-primary), var(--accent-secondary));
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  font-weight: 600;
  font-size: 0.875rem;
}

.header-btn {
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  color: var(--text-secondary);
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.header-btn:hover {
  background: var(--bg-card);
  color: var(--text-primary);
  border-color: var(--accent-primary);
}

.header-btn.active {
  background: var(--accent-primary);
  color: var(--bg-primary);
  border-color: var(--accent-primary);
}

.main-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  padding: 1rem;
  gap: 1rem;
  max-width: 1400px;
  margin: 0 auto;
  width: 100%;
}

.card {
  background: var(--bg-card);
  backdrop-filter: blur(10px);
  border: 1px solid var(--border-color);
  border-radius: 1rem;
  padding: 1.5rem;
}

.card-title {
  font-size: 1.125rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: var(--accent-primary);
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 1rem;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.form-group label {
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--text-secondary);
}

.form-group input,
.form-group select {
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 0.5rem;
  padding: 0.75rem;
  color: var(--text-primary);
  font-size: 1rem;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.form-group input:focus,
.form-group select:focus {
  outline: none;
  border-color: var(--accent-primary);
  box-shadow: 0 0 0 3px rgba(56, 189, 248, 0.2);
}

.form-group input::placeholder {
  color: var(--text-secondary);
}

.btn {
  background: linear-gradient(135deg, var(--accent-primary), var(--accent-secondary));
  border: none;
  border-radius: 0.5rem;
  padding: 0.75rem 1.5rem;
  color: var(--bg-primary);
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
}

.btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(56, 189, 248, 0.3);
}

.btn:active {
  transform: translateY(0);
}

.btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

.btn-secondary {
  background: var(--bg-secondary);
  color: var(--text-primary);
  border: 1px solid var(--border-color);
}

.btn-danger {
  background: linear-gradient(135deg, #ef4444, #dc2626);
}

.btn-small {
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
}

.stat-card {
  background: var(--bg-secondary);
  border-radius: 0.75rem;
  padding: 1rem;
  text-align: center;
}

.stat-value {
  font-size: 2rem;
  font-weight: 700;
  background: linear-gradient(135deg, var(--accent-primary), var(--accent-aurora));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.stat-label {
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--text-secondary);
  margin-top: 0.25rem;
}

.contacts-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  max-height: 500px;
  overflow-y: auto;
}

.contact-row {
  display: grid;
  grid-template-columns: 1fr auto auto;
  grid-template-rows: auto auto;
  gap: 0.25rem 1rem;
  padding: 0.75rem 1rem;
  background: var(--bg-secondary);
  border-radius: 0.5rem;
  border: 1px solid transparent;
  transition: all 0.2s;
}

.contact-row:hover {
  border-color: var(--border-color);
  background: rgba(56, 189, 248, 0.05);
}

.contact-main {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  grid-column: 1;
  grid-row: 1;
}

.contact-callsign {
  font-size: 1.125rem;
  font-weight: 700;
  color: var(--accent-primary);
}

.contact-exchange {
  font-family: 'Monaco', 'Menlo', monospace;
  font-size: 0.875rem;
  color: var(--accent-aurora);
  background: rgba(52, 211, 153, 0.15);
  padding: 0.125rem 0.5rem;
  border-radius: 0.25rem;
}

.contact-details {
  display: flex;
  align-items: center;
  gap: 1rem;
  grid-column: 1;
  grid-row: 2;
  font-size: 0.8rem;
  color: var(--text-secondary);
}

.contact-freq {
  font-family: 'Monaco', 'Menlo', monospace;
}

.contact-mode {
  background: var(--bg-secondary);
  padding: 0.125rem 0.375rem;
  border-radius: 0.25rem;
}

.contact-qth {
  grid-column: 2;
  grid-row: 1 / 3;
  display: flex;
  align-items: center;
  font-size: 0.8rem;
  color: var(--text-secondary);
  max-width: 150px;
  text-align: right;
}

.contact-actions {
  grid-column: 3;
  grid-row: 1 / 3;
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.btn-icon {
  background: transparent;
  border: none;
  color: var(--text-secondary);
  cursor: pointer;
  padding: 0.375rem;
  border-radius: 0.25rem;
  transition: all 0.2s;
  font-size: 1rem;
}

.btn-icon:hover {
  color: var(--accent-primary);
  background: rgba(56, 189, 248, 0.1);
}

.btn-icon.delete:hover {
  color: var(--error);
  background: rgba(248, 113, 113, 0.1);
}

.contacts-empty {
  text-align: center;
  padding: 2rem;
  color: var(--text-secondary);
}

.map-view {
  flex: 1 1;
  position: relative;
  display: flex;
}

.map-fullscreen {
  flex: 1 1;
  height: calc(100vh - 60px);
}

.map-fullscreen .leaflet-container {
  height: 100%;
  width: 100%;
  border-radius: 0;
}

.map-overlay {
  position: absolute;
  top: 50%;
  left: 1.5rem;
  transform: translateY(-50%);
  width: 220px;
  max-height: 280px;
  background: var(--bg-card);
  backdrop-filter: blur(10px);
  border: 1px solid var(--border-color);
  border-radius: 0.75rem;
  overflow: hidden;
  z-index: 1000;
}

.map-overlay-title {
  padding: 0.5rem 0.75rem;
  margin: 0;
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--accent-primary);
  background: var(--bg-secondary);
  border-bottom: 1px solid var(--border-color);
}

.map-overlay-list {
  max-height: 220px;
  overflow-y: auto;
}

.map-overlay-contact {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 0.5rem 0.75rem;
  border-bottom: 1px solid var(--border-color);
}

.overlay-row-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.overlay-row-bottom {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  font-size: 0.7rem;
  color: var(--text-secondary);
}

.overlay-mode {
  background: var(--bg-secondary);
  padding: 0.1rem 0.3rem;
  border-radius: 0.2rem;
  font-size: 0.65rem;
}

.map-overlay-contact:last-child {
  border-bottom: none;
}

.overlay-callsign {
  font-weight: 600;
  color: var(--text-primary);
  font-size: 0.85rem;
}

.overlay-exchange {
  font-family: 'Monaco', 'Menlo', monospace;
  font-size: 0.75rem;
  color: var(--accent-aurora);
  background: rgba(52, 211, 153, 0.15);
  padding: 0.125rem 0.375rem;
  border-radius: 0.25rem;
}

.overlay-freq {
  font-family: 'Monaco', 'Menlo', monospace;
  font-size: 0.7rem;
  color: var(--text-secondary);
}

.overlay-time {
  margin-left: auto;
  font-size: 0.75rem;
  color: var(--text-secondary);
}

.new-overlay-contact {
  animation: overlaySlideIn 0.4s ease-out, flash 0.5s ease-out 0.4s;
}

@keyframes overlaySlideIn {
  0% {
    opacity: 0;
    transform: translateY(-10px);
    max-height: 0;
  }
  100% {
    opacity: 1;
    transform: translateY(0);
    max-height: 50px;
  }
}

.map-overlay-empty {
  padding: 1.5rem;
  text-align: center;
  color: var(--text-secondary);
  font-size: 0.875rem;
}

.exchange-display {
  background: linear-gradient(135deg, rgba(56, 189, 248, 0.15), rgba(52, 211, 153, 0.15));
  border: 1px solid var(--accent-primary);
  border-radius: 0.5rem;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.exchange-label {
  color: var(--text-secondary);
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.exchange-callsign {
  font-size: 1.5rem;
  font-weight: 700;
  font-family: 'Monaco', 'Menlo', monospace;
  color: var(--accent-primary);
}

.exchange-value {
  font-size: 1.5rem;
  font-weight: 700;
  font-family: 'Monaco', 'Menlo', monospace;
  background: linear-gradient(135deg, var(--accent-primary), var(--accent-aurora));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.exchange-grid {
  color: var(--text-secondary);
  font-size: 0.875rem;
  margin-left: auto;
}

.map-container {
  height: 400px;
  border-radius: 0.75rem;
  overflow: hidden;
}

.tabs {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.tab {
  background: transparent;
  border: 1px solid var(--border-color);
  border-radius: 0.5rem;
  padding: 0.5rem 1rem;
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 0.2s;
}

.tab.active {
  background: var(--accent-primary);
  border-color: var(--accent-primary);
  color: var(--bg-primary);
}

.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.login-card {
  background: var(--bg-card);
  backdrop-filter: blur(10px);
  border: 1px solid var(--border-color);
  border-radius: 1.5rem;
  padding: 3rem;
  width: 100%;
  max-width: 400px;
  text-align: center;
}

.login-logo {
  font-size: 3rem;
  font-weight: 700;
  background: linear-gradient(135deg, var(--accent-primary), var(--accent-aurora));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 0.5rem;
}

.login-subtitle {
  color: var(--text-secondary);
  margin-bottom: 2rem;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.login-input {
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 0.75rem;
  padding: 1rem;
  color: var(--text-primary);
  font-size: 1.25rem;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 0.1em;
}

.login-input:focus {
  outline: none;
  border-color: var(--accent-primary);
  box-shadow: 0 0 0 3px rgba(56, 189, 248, 0.2);
}

.error-message {
  background: rgba(248, 113, 113, 0.1);
  border: 1px solid var(--error);
  border-radius: 0.5rem;
  padding: 0.75rem;
  color: var(--error);
  font-size: 0.875rem;
}

.success-message {
  background: rgba(74, 222, 128, 0.1);
  border: 1px solid var(--success);
  border-radius: 0.5rem;
  padding: 0.75rem;
  color: var(--success);
  font-size: 0.875rem;
}

.whitelist-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem;
  background: var(--bg-secondary);
  border-radius: 0.5rem;
  margin-bottom: 0.5rem;
}

.whitelist-callsign {
  font-weight: 600;
  font-family: monospace;
  font-size: 1rem;
}

.admin-badge {
  background: var(--accent-aurora);
  color: var(--bg-primary);
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  font-size: 0.75rem;
  font-weight: 600;
  margin-left: 0.5rem;
}

.new-contact-flash {
  animation: slideIn 0.4s ease-out, flash 0.5s ease-out 0.4s;
}

@keyframes slideIn {
  0% {
    opacity: 0;
    transform: translateX(-20px);
    max-height: 0;
  }
  100% {
    opacity: 1;
    transform: translateX(0);
    max-height: 100px;
  }
}

@keyframes flash {
  0% {
    background: rgba(52, 211, 153, 0.3);
  }
  100% {
    background: transparent;
  }
}

.table-scroll {
  max-height: 300px;
  overflow-y: auto;
}

.charts-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
}

.chart-container {
  min-height: 200px;
}

.chart-title {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--accent-primary);
  margin-bottom: 1rem;
}

.chart-bars {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.chart-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.chart-label {
  width: 60px;
  font-size: 0.75rem;
  font-weight: 500;
  color: var(--text-secondary);
  text-align: right;
  flex-shrink: 0;
}

.chart-bar-bg {
  flex: 1 1;
  height: 20px;
  background: var(--bg-secondary);
  border-radius: 4px;
  overflow: hidden;
}

.chart-bar-fill {
  height: 100%;
  border-radius: 4px;
  transition: width 0.3s ease;
}

.chart-value {
  width: 30px;
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--text-primary);
  text-align: right;
  flex-shrink: 0;
}

.qth-cell {
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
}

.grid-badge {
  font-family: monospace;
  font-size: 0.7rem;
  background: var(--accent-primary);
  color: var(--bg-primary);
  padding: 0.125rem 0.375rem;
  border-radius: 0.25rem;
  font-weight: 600;
  display: inline-block;
  width: fit-content;
}

.qth-location {
  font-size: 0.7rem;
  color: var(--text-secondary);
}

.objectives-card {
  margin-top: 1rem;
}

.objectives-summary {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
  margin-bottom: 1.5rem;
  padding: 1rem;
  background: var(--bg-secondary);
  border-radius: 0.75rem;
}

.objective-stat {
  text-align: center;
}

.objective-stat-value {
  display: block;
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--accent-primary);
}

.objective-stat.highlight .objective-stat-value {
  background: linear-gradient(135deg, var(--accent-primary), var(--accent-aurora));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-size: 1.75rem;
}

.objective-stat-label {
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--text-secondary);
}

.objectives-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.objective-item {
  display: flex;
  gap: 1rem;
  padding: 1rem;
  background: var(--bg-secondary);
  border-radius: 0.5rem;
  border: 1px solid transparent;
  transition: all 0.2s;
}

.objective-item:hover {
  border-color: var(--border-color);
}

.objective-item.completed {
  border-color: var(--accent-aurora);
  background: rgba(52, 211, 153, 0.1);
}

.objective-item.auto-detected {
  border-color: var(--accent-primary);
  background: rgba(56, 189, 248, 0.1);
}

.objective-checkbox {
  width: 24px;
  height: 24px;
  border: 2px solid var(--border-color);
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 14px;
  color: var(--accent-aurora);
  font-weight: bold;
}

.objective-item.completed .objective-checkbox {
  border-color: var(--accent-aurora);
  background: var(--accent-aurora);
  color: var(--bg-primary);
}

.objective-content {
  flex: 1 1;
}

.objective-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.25rem;
}

.objective-name {
  font-weight: 600;
  color: var(--text-primary);
}

.objective-multiplier {
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--accent-aurora);
  background: rgba(52, 211, 153, 0.2);
  padding: 0.125rem 0.5rem;
  border-radius: 1rem;
}

.objective-description {
  font-size: 0.8rem;
  color: var(--text-secondary);
  line-height: 1.4;
  margin: 0;
}

.auto-badge {
  display: inline-block;
  font-size: 0.65rem;
  background: var(--accent-primary);
  color: var(--bg-primary);
  padding: 0.125rem 0.375rem;
  border-radius: 0.25rem;
  margin-top: 0.5rem;
  font-weight: 600;
}

.objectives-note {
  font-size: 0.75rem;
  color: var(--text-secondary);
  text-align: center;
  margin-top: 1rem;
  font-style: italic;
}

.settings-section {
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid var(--border-color);
}

.settings-title {
  font-size: 1rem;
  font-weight: 600;
  color: var(--accent-primary);
  margin-bottom: 1rem;
}

.settings-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 1rem;
  margin-bottom: 1rem;
}

.exchange-preview {
  background: var(--bg-secondary);
  padding: 0.75rem 1rem;
  border-radius: 0.5rem;
  font-family: monospace;
  font-size: 1rem;
  margin-bottom: 1rem;
}

.exchange-preview .grid-info {
  color: var(--text-secondary);
  font-size: 0.85rem;
}

.settings-actions {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.error-text {
  color: var(--error);
  font-size: 0.75rem;
}

.success-text {
  color: var(--success);
  font-size: 0.875rem;
}

input.invalid {
  border-color: var(--error) !important;
}

.stats-grid-7 {
  grid-template-columns: repeat(7, 1fr);
}

.stat-card-highlight {
  background: linear-gradient(135deg, rgba(56, 189, 248, 0.2), rgba(52, 211, 153, 0.2));
  border: 1px solid var(--accent-aurora);
}

.stat-card-highlight .stat-value {
  background: linear-gradient(135deg, var(--accent-primary), var(--accent-aurora));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1rem;
}

.modal-content {
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: 1rem;
  max-width: 800px;
  max-height: 90vh;
  width: 100%;
  overflow-y: auto;
  position: relative;
  padding: 1.5rem;
}

.modal-close {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 50%;
  width: 32px;
  height: 32px;
  font-size: 1.25rem;
  color: var(--text-secondary);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.modal-close:hover {
  background: var(--error);
  border-color: var(--error);
  color: white;
}

.log-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.log-list-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
}

.log-list-filters {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  flex-wrap: wrap;
}

.log-filter-select {
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 0.5rem;
  padding: 0.5rem 0.75rem;
  color: var(--text-primary);
  font-size: 0.875rem;
}

.log-filter-input {
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 0.5rem;
  padding: 0.5rem 0.75rem;
  color: var(--text-primary);
  font-size: 0.875rem;
  width: 150px;
}

.log-filter-input:focus,
.log-filter-select:focus {
  outline: none;
  border-color: var(--accent-primary);
}

.log-list-stats {
  font-size: 0.875rem;
  color: var(--text-secondary);
}

.log-table-container {
  overflow-x: auto;
  max-height: 70vh;
  overflow-y: auto;
}

.log-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.875rem;
}

.log-table th {
  background: var(--bg-secondary);
  padding: 0.75rem 0.5rem;
  text-align: left;
  font-weight: 600;
  color: var(--text-secondary);
  text-transform: uppercase;
  font-size: 0.7rem;
  letter-spacing: 0.05em;
  border-bottom: 1px solid var(--border-color);
  position: sticky;
  top: 0;
  z-index: 10;
}

.log-table th:hover {
  color: var(--accent-primary);
}

.log-table td {
  padding: 0.5rem;
  vertical-align: middle;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.log-table tbody tr {
  border-bottom: 1px solid var(--border-color);
}

.log-table tr:hover {
  background: rgba(56, 189, 248, 0.05);
}

.log-table tr.has-issues {
  background: rgba(248, 113, 113, 0.05);
}

.log-table tr.has-issues:hover {
  background: rgba(248, 113, 113, 0.1);
}

.log-time {
  font-family: 'Monaco', 'Menlo', monospace;
  font-size: 0.75rem;
  white-space: nowrap;
}

.log-callsign {
  font-weight: 600;
  color: var(--accent-primary);
}

.log-issues {
  display: flex;
  gap: 0.25rem;
  flex-wrap: wrap;
}

.issue-tag {
  background: rgba(248, 113, 113, 0.2);
  color: var(--error);
  padding: 0.125rem 0.375rem;
  border-radius: 0.25rem;
  font-size: 0.65rem;
  font-weight: 600;
  white-space: nowrap;
}

.cell-warning {
  background: rgba(248, 113, 113, 0.15);
  color: var(--error);
}

.log-actions {
  white-space: nowrap;
  text-align: left;
}

.log-actions .btn-icon {
  margin-right: 0.25rem;
}

.log-issues {
  min-width: 80px;
}

.log-table td.log-issues,
.log-table td.log-actions {
  vertical-align: middle;
}

.btn-icon.save {
  color: var(--success);
}

.btn-icon.save:hover {
  background: rgba(74, 222, 128, 0.1);
}

.log-edit-input {
  background: var(--bg-secondary);
  border: 1px solid var(--accent-primary);
  border-radius: 0.25rem;
  padding: 0.25rem 0.5rem;
  color: var(--text-primary);
  font-size: 0.8rem;
  width: 100%;
}

.log-edit-input:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(56, 189, 248, 0.2);
}

.log-edit-small {
  width: 60px;
}

.log-edit-freq {
  width: 80px;
}

/* ── datetime-local: prevent internal content overflow ── */
input[type="datetime-local"] {
  padding-right: 0.75rem;
  min-width: 0;
  width: 100%;
}

/* ── CustomSelect ─────────────────────────────────────── */
.custom-select-container {
  position: relative;
}

.custom-select-trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 0.5rem;
  padding: 0.75rem;
  color: var(--text-primary);
  font-size: 1rem;
  cursor: pointer;
  transition: border-color 0.2s, box-shadow 0.2s;
  width: 100%;
  min-height: 0;
  line-height: normal;
}

.custom-select-trigger:focus {
  outline: none;
  border-color: var(--accent-primary);
  box-shadow: 0 0 0 3px rgba(56, 189, 248, 0.2);
}

.custom-select-container.open .custom-select-trigger {
  border-color: var(--accent-primary);
  box-shadow: 0 0 0 3px rgba(56, 189, 248, 0.2);
}

.custom-select-container.disabled .custom-select-trigger {
  opacity: 0.5;
  cursor: not-allowed;
}

.custom-select-value {
  flex: 1 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
}

.custom-select-arrow {
  font-size: 0.6rem;
  color: var(--text-secondary);
  flex-shrink: 0;
}

.custom-select-list {
  background: var(--bg-secondary);
  border: 1px solid var(--accent-primary);
  border-radius: 0.5rem;
  max-height: 220px;
  overflow-y: auto;
  list-style: none;
  padding: 0.25rem 0;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
}

.custom-select-option {
  padding: 0.6rem 0.75rem;
  font-size: 0.9rem;
  color: var(--text-primary);
  cursor: pointer;
  transition: background 0.1s;
}

.custom-select-option:hover,
.custom-select-option.focused {
  background: rgba(56, 189, 248, 0.12);
}

.custom-select-option.selected {
  color: var(--accent-primary);
  font-weight: 600;
}

/* Smaller variant for log table inline edit */
.custom-select-sm .custom-select-trigger {
  padding: 0.25rem 0.5rem;
  font-size: 0.8rem;
  border-radius: 0.25rem;
  border-color: var(--accent-primary);
  background: var(--bg-secondary);
}

.custom-select-sm .custom-select-list {
  font-size: 0.8rem;
}

.custom-select-sm .custom-select-option {
  padding: 0.4rem 0.5rem;
}

@media (max-width: 768px) {
  .main-content {
    padding: 0.75rem;
  }

  .card {
    padding: 1rem;
  }

  .stats-grid,
  .stats-grid-7 {
    grid-template-columns: repeat(2, 1fr);
    gap: 0.5rem;
  }
  
  .stats-grid-7 .stat-card:last-child {
    grid-column: span 2;
  }

  .stat-card {
    padding: 0.75rem 0.5rem;
  }

  .stat-value {
    font-size: 1.25rem;
  }

  .stat-label {
    font-size: 0.6rem;
  }
  
  .form-grid {
    grid-template-columns: 1fr;
  }

  .form-group input,
  .form-group select {
    font-size: 16px;
  }

  .btn {
    width: 100%;
    padding: 0.75rem;
  }

  .btn-small {
    width: auto;
    padding: 0.375rem 0.75rem;
  }
  
  .header {
    flex-direction: column;
    gap: 0.5rem;
    padding: 0.75rem;
  }

  .user-info {
    flex-wrap: wrap;
    justify-content: center;
  }

  .tabs {
    margin-bottom: 0.5rem;
  }

  .map-container {
    height: 250px;
  }

  .charts-grid {
    grid-template-columns: 1fr;
  }

  .contact-row {
    grid-template-columns: 1fr auto;
    grid-template-rows: auto auto auto;
  }

  .contact-main {
    flex-wrap: wrap;
    gap: 0.5rem;
  }

  .contact-callsign {
    font-size: 1rem;
  }

  .contact-details {
    flex-wrap: wrap;
    gap: 0.5rem;
  }

  .contact-qth {
    grid-column: 1;
    grid-row: 3;
    text-align: left;
    max-width: none;
  }

  .contact-actions {
    grid-column: 2;
    grid-row: 1 / 4;
  }

  .grid-badge {
    font-size: 0.65rem;
    padding: 0.1rem 0.25rem;
  }

  .objectives-summary {
    grid-template-columns: repeat(2, 1fr);
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,gCAAgC;EAChC,yBAAyB;EACzB,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,yBAAyB;EACzB,wCAAwC;EACxC,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE;IACE,qBAAqB;IACrB,uBAAuB;IACvB,oCAAoC;IACpC,yBAAyB;IACzB,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,yBAAyB;IACzB,sCAAsC;IACtC,gBAAgB;IAChB,kBAAkB;IAClB,4BAA4B;IAC5B,4BAA4B;EAC9B;AACF;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,8FAA8F;EAC9F,iIAAiI;EACjI,uCAAuC;EACvC,0BAA0B;EAC1B,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,4CAA4C;EAC5C,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gFAAgF;EAChF,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mFAAmF;EACnF,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,4BAA4B;EAC5B,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,mCAAmC;AACrC;;AAEA;EACE,iCAAiC;EACjC,wBAAwB;EACxB,mCAAmC;AACrC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;;EAEE,+BAA+B;EAC/B,qCAAqC;EACrC,qBAAqB;EACrB,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,8CAA8C;AAChD;;AAEA;;EAEE,aAAa;EACb,mCAAmC;EACnC,6CAA6C;AAC/C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,mFAAmF;EACnF,YAAY;EACZ,qBAAqB;EACrB,uBAAuB;EACvB,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,sBAAsB;EACtB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gFAAgF;EAChF,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,6BAA6B;EAC7B,iBAAiB;EACjB,qBAAqB;EACrB,+BAA+B;EAC/B,qBAAqB;EACrB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;EACnB,2BAA2B;EAC3B,oCAAoC;EACpC,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,SAAO;EACP,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,2BAA2B;EAC3B,YAAY;EACZ,iBAAiB;EACjB,0BAA0B;EAC1B,2BAA2B;EAC3B,qCAAqC;EACrC,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,+BAA+B;EAC/B,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;EAClB,2BAA2B;EAC3B,oCAAoC;EACpC,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,yCAAyC;EACzC,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,iEAAiE;AACnE;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;IAC5B,aAAa;EACf;EACA;IACE,UAAU;IACV,wBAAwB;IACxB,gBAAgB;EAClB;AACF;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,uFAAuF;EACvF,uCAAuC;EACvC,qBAAqB;EACrB,qBAAqB;EACrB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yCAAyC;EACzC,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yCAAyC;EACzC,gFAAgF;EAChF,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,qCAAqC;EACrC,qBAAqB;EACrB,oBAAoB;EACpB,4BAA4B;EAC5B,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;EACnC,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,qCAAqC;EACrC,qBAAqB;EACrB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gFAAgF;EAChF,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,sBAAsB;EACtB,aAAa;EACb,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,6CAA6C;AAC/C;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,gCAAgC;EAChC,qBAAqB;EACrB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;EAC/B,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;IAC5B,aAAa;EACf;EACA;IACE,UAAU;IACV,wBAAwB;IACxB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,mCAAmC;EACrC;EACA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,iCAAiC;EACjC,wBAAwB;EACxB,0BAA0B;EAC1B,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,qBAAqB;EACrB,aAAa;EACb,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,gFAAgF;EAChF,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,+BAA+B;EAC/B,qBAAqB;EACrB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;EACnC,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,mCAAmC;EACnC,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,iCAAiC;EACjC,wBAAwB;EACxB,0BAA0B;EAC1B,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qFAAqF;EACrF,sCAAsC;AACxC;;AAEA;EACE,gFAAgF;EAChF,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,qBAAqB;EACrB,uBAAuB;EACvB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,qBAAqB;EACrB,uBAAuB;EACvB,0BAA0B;EAC1B,mBAAmB;EACnB,YAAY;AACd;;AAEA;;EAEE,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,iBAAiB;EACjB,sBAAsB;EACtB,4CAA4C;EAC5C,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,0BAA0B;EAC1B,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,+BAA+B;EAC/B,uCAAuC;EACvC,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA,4DAA4D;AAC5D;EACE,sBAAsB;EACtB,YAAY;EACZ,WAAW;AACb;;AAEA,4DAA4D;AAC5D;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,+BAA+B;EAC/B,qCAAqC;EACrC,qBAAqB;EACrB,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,eAAe;EACf,8CAA8C;EAC9C,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,6CAA6C;AAC/C;;AAEA;EACE,mCAAmC;EACnC,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,uCAAuC;EACvC,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,0BAA0B;EAC1B,eAAe;EACf,2BAA2B;AAC7B;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,8CAA8C;AAC9C;EACE,uBAAuB;EACvB,iBAAiB;EACjB,sBAAsB;EACtB,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,qCAAqC;IACrC,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,+BAA+B;IAC/B,kCAAkC;EACpC;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,qCAAqC;EACvC;AACF","sourcesContent":[":root {\n  --bg-primary: #0f172a;\n  --bg-secondary: #1e293b;\n  --bg-card: rgba(30, 41, 59, 0.8);\n  --accent-primary: #38bdf8;\n  --accent-secondary: #22d3ee;\n  --accent-aurora: #34d399;\n  --text-primary: #f1f5f9;\n  --text-secondary: #94a3b8;\n  --border-color: rgba(148, 163, 184, 0.2);\n  --error: #f87171;\n  --success: #4ade80;\n  --body-gradient-mid: #1e3a5f;\n  --body-gradient-end: #134e4a;\n}\n\n@media (prefers-color-scheme: light) {\n  :root {\n    --bg-primary: #f1f5f9;\n    --bg-secondary: #e2e8f0;\n    --bg-card: rgba(255, 255, 255, 0.85);\n    --accent-primary: #0284c7;\n    --accent-secondary: #0891b2;\n    --accent-aurora: #059669;\n    --text-primary: #0f172a;\n    --text-secondary: #475569;\n    --border-color: rgba(71, 85, 105, 0.2);\n    --error: #dc2626;\n    --success: #16a34a;\n    --body-gradient-mid: #bfdbfe;\n    --body-gradient-end: #a7f3d0;\n  }\n}\n\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\nbody {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, sans-serif;\n  background: linear-gradient(135deg, var(--bg-primary) 0%, var(--body-gradient-mid) 50%, var(--body-gradient-end) 100%) !important;\n  background-attachment: fixed !important;\n  color: var(--text-primary);\n  min-height: 100vh;\n  -webkit-font-smoothing: antialiased;\n}\n\nhtml {\n  background: var(--bg-primary);\n}\n\n.app-container {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  overflow-x: hidden;\n  max-width: 100vw;\n}\n\n.header {\n  background: var(--bg-card);\n  backdrop-filter: blur(10px);\n  border-bottom: 1px solid var(--border-color);\n  padding: 1rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.logo {\n  font-size: 1.5rem;\n  font-weight: 700;\n  background: linear-gradient(135deg, var(--accent-primary), var(--accent-aurora));\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.user-info {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.callsign-badge {\n  background: linear-gradient(135deg, var(--accent-primary), var(--accent-secondary));\n  padding: 0.5rem 1rem;\n  border-radius: 0.5rem;\n  font-weight: 600;\n  font-size: 0.875rem;\n}\n\n.header-btn {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  color: var(--text-secondary);\n  padding: 0.5rem 1rem;\n  border-radius: 0.5rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.header-btn:hover {\n  background: var(--bg-card);\n  color: var(--text-primary);\n  border-color: var(--accent-primary);\n}\n\n.header-btn.active {\n  background: var(--accent-primary);\n  color: var(--bg-primary);\n  border-color: var(--accent-primary);\n}\n\n.main-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  padding: 1rem;\n  gap: 1rem;\n  max-width: 1400px;\n  margin: 0 auto;\n  width: 100%;\n}\n\n.card {\n  background: var(--bg-card);\n  backdrop-filter: blur(10px);\n  border: 1px solid var(--border-color);\n  border-radius: 1rem;\n  padding: 1.5rem;\n}\n\n.card-title {\n  font-size: 1.125rem;\n  font-weight: 600;\n  margin-bottom: 1rem;\n  color: var(--accent-primary);\n}\n\n.form-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));\n  gap: 1rem;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.form-group label {\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--text-secondary);\n}\n\n.form-group input,\n.form-group select {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: 0.5rem;\n  padding: 0.75rem;\n  color: var(--text-primary);\n  font-size: 1rem;\n  transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.form-group input:focus,\n.form-group select:focus {\n  outline: none;\n  border-color: var(--accent-primary);\n  box-shadow: 0 0 0 3px rgba(56, 189, 248, 0.2);\n}\n\n.form-group input::placeholder {\n  color: var(--text-secondary);\n}\n\n.btn {\n  background: linear-gradient(135deg, var(--accent-primary), var(--accent-secondary));\n  border: none;\n  border-radius: 0.5rem;\n  padding: 0.75rem 1.5rem;\n  color: var(--bg-primary);\n  font-weight: 600;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(56, 189, 248, 0.3);\n}\n\n.btn:active {\n  transform: translateY(0);\n}\n\n.btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.btn-secondary {\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n  border: 1px solid var(--border-color);\n}\n\n.btn-danger {\n  background: linear-gradient(135deg, #ef4444, #dc2626);\n}\n\n.btn-small {\n  padding: 0.5rem 1rem;\n  font-size: 0.875rem;\n}\n\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 1rem;\n}\n\n.stat-card {\n  background: var(--bg-secondary);\n  border-radius: 0.75rem;\n  padding: 1rem;\n  text-align: center;\n}\n\n.stat-value {\n  font-size: 2rem;\n  font-weight: 700;\n  background: linear-gradient(135deg, var(--accent-primary), var(--accent-aurora));\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.stat-label {\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--text-secondary);\n  margin-top: 0.25rem;\n}\n\n.contacts-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  max-height: 500px;\n  overflow-y: auto;\n}\n\n.contact-row {\n  display: grid;\n  grid-template-columns: 1fr auto auto;\n  grid-template-rows: auto auto;\n  gap: 0.25rem 1rem;\n  padding: 0.75rem 1rem;\n  background: var(--bg-secondary);\n  border-radius: 0.5rem;\n  border: 1px solid transparent;\n  transition: all 0.2s;\n}\n\n.contact-row:hover {\n  border-color: var(--border-color);\n  background: rgba(56, 189, 248, 0.05);\n}\n\n.contact-main {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  grid-column: 1;\n  grid-row: 1;\n}\n\n.contact-callsign {\n  font-size: 1.125rem;\n  font-weight: 700;\n  color: var(--accent-primary);\n}\n\n.contact-exchange {\n  font-family: 'Monaco', 'Menlo', monospace;\n  font-size: 0.875rem;\n  color: var(--accent-aurora);\n  background: rgba(52, 211, 153, 0.15);\n  padding: 0.125rem 0.5rem;\n  border-radius: 0.25rem;\n}\n\n.contact-details {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  grid-column: 1;\n  grid-row: 2;\n  font-size: 0.8rem;\n  color: var(--text-secondary);\n}\n\n.contact-freq {\n  font-family: 'Monaco', 'Menlo', monospace;\n}\n\n.contact-mode {\n  background: var(--bg-secondary);\n  padding: 0.125rem 0.375rem;\n  border-radius: 0.25rem;\n}\n\n.contact-qth {\n  grid-column: 2;\n  grid-row: 1 / 3;\n  display: flex;\n  align-items: center;\n  font-size: 0.8rem;\n  color: var(--text-secondary);\n  max-width: 150px;\n  text-align: right;\n}\n\n.contact-actions {\n  grid-column: 3;\n  grid-row: 1 / 3;\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n.btn-icon {\n  background: transparent;\n  border: none;\n  color: var(--text-secondary);\n  cursor: pointer;\n  padding: 0.375rem;\n  border-radius: 0.25rem;\n  transition: all 0.2s;\n  font-size: 1rem;\n}\n\n.btn-icon:hover {\n  color: var(--accent-primary);\n  background: rgba(56, 189, 248, 0.1);\n}\n\n.btn-icon.delete:hover {\n  color: var(--error);\n  background: rgba(248, 113, 113, 0.1);\n}\n\n.contacts-empty {\n  text-align: center;\n  padding: 2rem;\n  color: var(--text-secondary);\n}\n\n.map-view {\n  flex: 1;\n  position: relative;\n  display: flex;\n}\n\n.map-fullscreen {\n  flex: 1;\n  height: calc(100vh - 60px);\n}\n\n.map-fullscreen .leaflet-container {\n  height: 100%;\n  width: 100%;\n  border-radius: 0;\n}\n\n.map-overlay {\n  position: absolute;\n  top: 50%;\n  left: 1.5rem;\n  transform: translateY(-50%);\n  width: 220px;\n  max-height: 280px;\n  background: var(--bg-card);\n  backdrop-filter: blur(10px);\n  border: 1px solid var(--border-color);\n  border-radius: 0.75rem;\n  overflow: hidden;\n  z-index: 1000;\n}\n\n.map-overlay-title {\n  padding: 0.5rem 0.75rem;\n  margin: 0;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--accent-primary);\n  background: var(--bg-secondary);\n  border-bottom: 1px solid var(--border-color);\n}\n\n.map-overlay-list {\n  max-height: 220px;\n  overflow-y: auto;\n}\n\n.map-overlay-contact {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  padding: 0.5rem 0.75rem;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.overlay-row-top {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.overlay-row-bottom {\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n  font-size: 0.7rem;\n  color: var(--text-secondary);\n}\n\n.overlay-mode {\n  background: var(--bg-secondary);\n  padding: 0.1rem 0.3rem;\n  border-radius: 0.2rem;\n  font-size: 0.65rem;\n}\n\n.map-overlay-contact:last-child {\n  border-bottom: none;\n}\n\n.overlay-callsign {\n  font-weight: 600;\n  color: var(--text-primary);\n  font-size: 0.85rem;\n}\n\n.overlay-exchange {\n  font-family: 'Monaco', 'Menlo', monospace;\n  font-size: 0.75rem;\n  color: var(--accent-aurora);\n  background: rgba(52, 211, 153, 0.15);\n  padding: 0.125rem 0.375rem;\n  border-radius: 0.25rem;\n}\n\n.overlay-freq {\n  font-family: 'Monaco', 'Menlo', monospace;\n  font-size: 0.7rem;\n  color: var(--text-secondary);\n}\n\n.overlay-time {\n  margin-left: auto;\n  font-size: 0.75rem;\n  color: var(--text-secondary);\n}\n\n.new-overlay-contact {\n  animation: overlaySlideIn 0.4s ease-out, flash 0.5s ease-out 0.4s;\n}\n\n@keyframes overlaySlideIn {\n  0% {\n    opacity: 0;\n    transform: translateY(-10px);\n    max-height: 0;\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n    max-height: 50px;\n  }\n}\n\n.map-overlay-empty {\n  padding: 1.5rem;\n  text-align: center;\n  color: var(--text-secondary);\n  font-size: 0.875rem;\n}\n\n.exchange-display {\n  background: linear-gradient(135deg, rgba(56, 189, 248, 0.15), rgba(52, 211, 153, 0.15));\n  border: 1px solid var(--accent-primary);\n  border-radius: 0.5rem;\n  padding: 0.75rem 1rem;\n  margin-bottom: 1rem;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n}\n\n.exchange-label {\n  color: var(--text-secondary);\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.exchange-callsign {\n  font-size: 1.5rem;\n  font-weight: 700;\n  font-family: 'Monaco', 'Menlo', monospace;\n  color: var(--accent-primary);\n}\n\n.exchange-value {\n  font-size: 1.5rem;\n  font-weight: 700;\n  font-family: 'Monaco', 'Menlo', monospace;\n  background: linear-gradient(135deg, var(--accent-primary), var(--accent-aurora));\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.exchange-grid {\n  color: var(--text-secondary);\n  font-size: 0.875rem;\n  margin-left: auto;\n}\n\n.map-container {\n  height: 400px;\n  border-radius: 0.75rem;\n  overflow: hidden;\n}\n\n.tabs {\n  display: flex;\n  gap: 0.5rem;\n  margin-bottom: 1rem;\n}\n\n.tab {\n  background: transparent;\n  border: 1px solid var(--border-color);\n  border-radius: 0.5rem;\n  padding: 0.5rem 1rem;\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.tab.active {\n  background: var(--accent-primary);\n  border-color: var(--accent-primary);\n  color: var(--bg-primary);\n}\n\n.login-container {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n}\n\n.login-card {\n  background: var(--bg-card);\n  backdrop-filter: blur(10px);\n  border: 1px solid var(--border-color);\n  border-radius: 1.5rem;\n  padding: 3rem;\n  width: 100%;\n  max-width: 400px;\n  text-align: center;\n}\n\n.login-logo {\n  font-size: 3rem;\n  font-weight: 700;\n  background: linear-gradient(135deg, var(--accent-primary), var(--accent-aurora));\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  margin-bottom: 0.5rem;\n}\n\n.login-subtitle {\n  color: var(--text-secondary);\n  margin-bottom: 2rem;\n}\n\n.login-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.login-input {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: 0.75rem;\n  padding: 1rem;\n  color: var(--text-primary);\n  font-size: 1.25rem;\n  text-align: center;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n}\n\n.login-input:focus {\n  outline: none;\n  border-color: var(--accent-primary);\n  box-shadow: 0 0 0 3px rgba(56, 189, 248, 0.2);\n}\n\n.error-message {\n  background: rgba(248, 113, 113, 0.1);\n  border: 1px solid var(--error);\n  border-radius: 0.5rem;\n  padding: 0.75rem;\n  color: var(--error);\n  font-size: 0.875rem;\n}\n\n.success-message {\n  background: rgba(74, 222, 128, 0.1);\n  border: 1px solid var(--success);\n  border-radius: 0.5rem;\n  padding: 0.75rem;\n  color: var(--success);\n  font-size: 0.875rem;\n}\n\n.whitelist-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.75rem;\n  background: var(--bg-secondary);\n  border-radius: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n\n.whitelist-callsign {\n  font-weight: 600;\n  font-family: monospace;\n  font-size: 1rem;\n}\n\n.admin-badge {\n  background: var(--accent-aurora);\n  color: var(--bg-primary);\n  padding: 0.25rem 0.5rem;\n  border-radius: 0.25rem;\n  font-size: 0.75rem;\n  font-weight: 600;\n  margin-left: 0.5rem;\n}\n\n.new-contact-flash {\n  animation: slideIn 0.4s ease-out, flash 0.5s ease-out 0.4s;\n}\n\n@keyframes slideIn {\n  0% {\n    opacity: 0;\n    transform: translateX(-20px);\n    max-height: 0;\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n    max-height: 100px;\n  }\n}\n\n@keyframes flash {\n  0% {\n    background: rgba(52, 211, 153, 0.3);\n  }\n  100% {\n    background: transparent;\n  }\n}\n\n.table-scroll {\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n.charts-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 1rem;\n}\n\n.chart-container {\n  min-height: 200px;\n}\n\n.chart-title {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--accent-primary);\n  margin-bottom: 1rem;\n}\n\n.chart-bars {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.chart-row {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.chart-label {\n  width: 60px;\n  font-size: 0.75rem;\n  font-weight: 500;\n  color: var(--text-secondary);\n  text-align: right;\n  flex-shrink: 0;\n}\n\n.chart-bar-bg {\n  flex: 1;\n  height: 20px;\n  background: var(--bg-secondary);\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.chart-bar-fill {\n  height: 100%;\n  border-radius: 4px;\n  transition: width 0.3s ease;\n}\n\n.chart-value {\n  width: 30px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  text-align: right;\n  flex-shrink: 0;\n}\n\n.qth-cell {\n  display: flex;\n  flex-direction: column;\n  gap: 0.125rem;\n}\n\n.grid-badge {\n  font-family: monospace;\n  font-size: 0.7rem;\n  background: var(--accent-primary);\n  color: var(--bg-primary);\n  padding: 0.125rem 0.375rem;\n  border-radius: 0.25rem;\n  font-weight: 600;\n  display: inline-block;\n  width: fit-content;\n}\n\n.qth-location {\n  font-size: 0.7rem;\n  color: var(--text-secondary);\n}\n\n.objectives-card {\n  margin-top: 1rem;\n}\n\n.objectives-summary {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n  padding: 1rem;\n  background: var(--bg-secondary);\n  border-radius: 0.75rem;\n}\n\n.objective-stat {\n  text-align: center;\n}\n\n.objective-stat-value {\n  display: block;\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: var(--accent-primary);\n}\n\n.objective-stat.highlight .objective-stat-value {\n  background: linear-gradient(135deg, var(--accent-primary), var(--accent-aurora));\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  font-size: 1.75rem;\n}\n\n.objective-stat-label {\n  font-size: 0.7rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--text-secondary);\n}\n\n.objectives-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.objective-item {\n  display: flex;\n  gap: 1rem;\n  padding: 1rem;\n  background: var(--bg-secondary);\n  border-radius: 0.5rem;\n  border: 1px solid transparent;\n  transition: all 0.2s;\n}\n\n.objective-item:hover {\n  border-color: var(--border-color);\n}\n\n.objective-item.completed {\n  border-color: var(--accent-aurora);\n  background: rgba(52, 211, 153, 0.1);\n}\n\n.objective-item.auto-detected {\n  border-color: var(--accent-primary);\n  background: rgba(56, 189, 248, 0.1);\n}\n\n.objective-checkbox {\n  width: 24px;\n  height: 24px;\n  border: 2px solid var(--border-color);\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  font-size: 14px;\n  color: var(--accent-aurora);\n  font-weight: bold;\n}\n\n.objective-item.completed .objective-checkbox {\n  border-color: var(--accent-aurora);\n  background: var(--accent-aurora);\n  color: var(--bg-primary);\n}\n\n.objective-content {\n  flex: 1;\n}\n\n.objective-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.25rem;\n}\n\n.objective-name {\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.objective-multiplier {\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--accent-aurora);\n  background: rgba(52, 211, 153, 0.2);\n  padding: 0.125rem 0.5rem;\n  border-radius: 1rem;\n}\n\n.objective-description {\n  font-size: 0.8rem;\n  color: var(--text-secondary);\n  line-height: 1.4;\n  margin: 0;\n}\n\n.auto-badge {\n  display: inline-block;\n  font-size: 0.65rem;\n  background: var(--accent-primary);\n  color: var(--bg-primary);\n  padding: 0.125rem 0.375rem;\n  border-radius: 0.25rem;\n  margin-top: 0.5rem;\n  font-weight: 600;\n}\n\n.objectives-note {\n  font-size: 0.75rem;\n  color: var(--text-secondary);\n  text-align: center;\n  margin-top: 1rem;\n  font-style: italic;\n}\n\n.settings-section {\n  margin-top: 1.5rem;\n  padding-top: 1.5rem;\n  border-top: 1px solid var(--border-color);\n}\n\n.settings-title {\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--accent-primary);\n  margin-bottom: 1rem;\n}\n\n.settings-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.exchange-preview {\n  background: var(--bg-secondary);\n  padding: 0.75rem 1rem;\n  border-radius: 0.5rem;\n  font-family: monospace;\n  font-size: 1rem;\n  margin-bottom: 1rem;\n}\n\n.exchange-preview .grid-info {\n  color: var(--text-secondary);\n  font-size: 0.85rem;\n}\n\n.settings-actions {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.error-text {\n  color: var(--error);\n  font-size: 0.75rem;\n}\n\n.success-text {\n  color: var(--success);\n  font-size: 0.875rem;\n}\n\ninput.invalid {\n  border-color: var(--error) !important;\n}\n\n.stats-grid-7 {\n  grid-template-columns: repeat(7, 1fr);\n}\n\n.stat-card-highlight {\n  background: linear-gradient(135deg, rgba(56, 189, 248, 0.2), rgba(52, 211, 153, 0.2));\n  border: 1px solid var(--accent-aurora);\n}\n\n.stat-card-highlight .stat-value {\n  background: linear-gradient(135deg, var(--accent-primary), var(--accent-aurora));\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 1rem;\n}\n\n.modal-content {\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  border-radius: 1rem;\n  max-width: 800px;\n  max-height: 90vh;\n  width: 100%;\n  overflow-y: auto;\n  position: relative;\n  padding: 1.5rem;\n}\n\n.modal-close {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: 50%;\n  width: 32px;\n  height: 32px;\n  font-size: 1.25rem;\n  color: var(--text-secondary);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n}\n\n.modal-close:hover {\n  background: var(--error);\n  border-color: var(--error);\n  color: white;\n}\n\n.log-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.log-list-controls {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.log-list-filters {\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.log-filter-select {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: 0.5rem;\n  padding: 0.5rem 0.75rem;\n  color: var(--text-primary);\n  font-size: 0.875rem;\n}\n\n.log-filter-input {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: 0.5rem;\n  padding: 0.5rem 0.75rem;\n  color: var(--text-primary);\n  font-size: 0.875rem;\n  width: 150px;\n}\n\n.log-filter-input:focus,\n.log-filter-select:focus {\n  outline: none;\n  border-color: var(--accent-primary);\n}\n\n.log-list-stats {\n  font-size: 0.875rem;\n  color: var(--text-secondary);\n}\n\n.log-table-container {\n  overflow-x: auto;\n  max-height: 70vh;\n  overflow-y: auto;\n}\n\n.log-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.875rem;\n}\n\n.log-table th {\n  background: var(--bg-secondary);\n  padding: 0.75rem 0.5rem;\n  text-align: left;\n  font-weight: 600;\n  color: var(--text-secondary);\n  text-transform: uppercase;\n  font-size: 0.7rem;\n  letter-spacing: 0.05em;\n  border-bottom: 1px solid var(--border-color);\n  position: sticky;\n  top: 0;\n  z-index: 10;\n}\n\n.log-table th:hover {\n  color: var(--accent-primary);\n}\n\n.log-table td {\n  padding: 0.5rem;\n  vertical-align: middle;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.log-table tbody tr {\n  border-bottom: 1px solid var(--border-color);\n}\n\n.log-table tr:hover {\n  background: rgba(56, 189, 248, 0.05);\n}\n\n.log-table tr.has-issues {\n  background: rgba(248, 113, 113, 0.05);\n}\n\n.log-table tr.has-issues:hover {\n  background: rgba(248, 113, 113, 0.1);\n}\n\n.log-time {\n  font-family: 'Monaco', 'Menlo', monospace;\n  font-size: 0.75rem;\n  white-space: nowrap;\n}\n\n.log-callsign {\n  font-weight: 600;\n  color: var(--accent-primary);\n}\n\n.log-issues {\n  display: flex;\n  gap: 0.25rem;\n  flex-wrap: wrap;\n}\n\n.issue-tag {\n  background: rgba(248, 113, 113, 0.2);\n  color: var(--error);\n  padding: 0.125rem 0.375rem;\n  border-radius: 0.25rem;\n  font-size: 0.65rem;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.cell-warning {\n  background: rgba(248, 113, 113, 0.15);\n  color: var(--error);\n}\n\n.log-actions {\n  white-space: nowrap;\n  text-align: left;\n}\n\n.log-actions .btn-icon {\n  margin-right: 0.25rem;\n}\n\n.log-issues {\n  min-width: 80px;\n}\n\n.log-table td.log-issues,\n.log-table td.log-actions {\n  vertical-align: middle;\n}\n\n.btn-icon.save {\n  color: var(--success);\n}\n\n.btn-icon.save:hover {\n  background: rgba(74, 222, 128, 0.1);\n}\n\n.log-edit-input {\n  background: var(--bg-secondary);\n  border: 1px solid var(--accent-primary);\n  border-radius: 0.25rem;\n  padding: 0.25rem 0.5rem;\n  color: var(--text-primary);\n  font-size: 0.8rem;\n  width: 100%;\n}\n\n.log-edit-input:focus {\n  outline: none;\n  box-shadow: 0 0 0 2px rgba(56, 189, 248, 0.2);\n}\n\n.log-edit-small {\n  width: 60px;\n}\n\n.log-edit-freq {\n  width: 80px;\n}\n\n/* ── datetime-local: prevent internal content overflow ── */\ninput[type=\"datetime-local\"] {\n  padding-right: 0.75rem;\n  min-width: 0;\n  width: 100%;\n}\n\n/* ── CustomSelect ─────────────────────────────────────── */\n.custom-select-container {\n  position: relative;\n}\n\n.custom-select-trigger {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: 0.5rem;\n  padding: 0.75rem;\n  color: var(--text-primary);\n  font-size: 1rem;\n  cursor: pointer;\n  transition: border-color 0.2s, box-shadow 0.2s;\n  width: 100%;\n  min-height: 0;\n  line-height: normal;\n}\n\n.custom-select-trigger:focus {\n  outline: none;\n  border-color: var(--accent-primary);\n  box-shadow: 0 0 0 3px rgba(56, 189, 248, 0.2);\n}\n\n.custom-select-container.open .custom-select-trigger {\n  border-color: var(--accent-primary);\n  box-shadow: 0 0 0 3px rgba(56, 189, 248, 0.2);\n}\n\n.custom-select-container.disabled .custom-select-trigger {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.custom-select-value {\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  text-align: left;\n}\n\n.custom-select-arrow {\n  font-size: 0.6rem;\n  color: var(--text-secondary);\n  flex-shrink: 0;\n}\n\n.custom-select-list {\n  background: var(--bg-secondary);\n  border: 1px solid var(--accent-primary);\n  border-radius: 0.5rem;\n  max-height: 220px;\n  overflow-y: auto;\n  list-style: none;\n  padding: 0.25rem 0;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);\n}\n\n.custom-select-option {\n  padding: 0.6rem 0.75rem;\n  font-size: 0.9rem;\n  color: var(--text-primary);\n  cursor: pointer;\n  transition: background 0.1s;\n}\n\n.custom-select-option:hover,\n.custom-select-option.focused {\n  background: rgba(56, 189, 248, 0.12);\n}\n\n.custom-select-option.selected {\n  color: var(--accent-primary);\n  font-weight: 600;\n}\n\n/* Smaller variant for log table inline edit */\n.custom-select-sm .custom-select-trigger {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.8rem;\n  border-radius: 0.25rem;\n  border-color: var(--accent-primary);\n  background: var(--bg-secondary);\n}\n\n.custom-select-sm .custom-select-list {\n  font-size: 0.8rem;\n}\n\n.custom-select-sm .custom-select-option {\n  padding: 0.4rem 0.5rem;\n}\n\n@media (max-width: 768px) {\n  .main-content {\n    padding: 0.75rem;\n  }\n\n  .card {\n    padding: 1rem;\n  }\n\n  .stats-grid,\n  .stats-grid-7 {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 0.5rem;\n  }\n  \n  .stats-grid-7 .stat-card:last-child {\n    grid-column: span 2;\n  }\n\n  .stat-card {\n    padding: 0.75rem 0.5rem;\n  }\n\n  .stat-value {\n    font-size: 1.25rem;\n  }\n\n  .stat-label {\n    font-size: 0.6rem;\n  }\n  \n  .form-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .form-group input,\n  .form-group select {\n    font-size: 16px;\n  }\n\n  .btn {\n    width: 100%;\n    padding: 0.75rem;\n  }\n\n  .btn-small {\n    width: auto;\n    padding: 0.375rem 0.75rem;\n  }\n  \n  .header {\n    flex-direction: column;\n    gap: 0.5rem;\n    padding: 0.75rem;\n  }\n\n  .user-info {\n    flex-wrap: wrap;\n    justify-content: center;\n  }\n\n  .tabs {\n    margin-bottom: 0.5rem;\n  }\n\n  .map-container {\n    height: 250px;\n  }\n\n  .charts-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .contact-row {\n    grid-template-columns: 1fr auto;\n    grid-template-rows: auto auto auto;\n  }\n\n  .contact-main {\n    flex-wrap: wrap;\n    gap: 0.5rem;\n  }\n\n  .contact-callsign {\n    font-size: 1rem;\n  }\n\n  .contact-details {\n    flex-wrap: wrap;\n    gap: 0.5rem;\n  }\n\n  .contact-qth {\n    grid-column: 1;\n    grid-row: 3;\n    text-align: left;\n    max-width: none;\n  }\n\n  .contact-actions {\n    grid-column: 2;\n    grid-row: 1 / 4;\n  }\n\n  .grid-badge {\n    font-size: 0.65rem;\n    padding: 0.1rem 0.25rem;\n  }\n\n  .objectives-summary {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
